import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { PaymentMethodType } from './payment-method-type.enum';
import { PaymentTerm, PaymentTermSchema } from './payment-term.entity';

export const PaymentOptionSchema = z
    .object({
        paymentMethod: EnumSchema(PaymentMethodType),
        paymentTerm: PaymentTermSchema,
    })
    .strict();
export class PaymentOption extends FromSchema(PaymentOptionSchema) {
    paymentMethod: PaymentMethodType;
    paymentTerm: PaymentTerm;
}
